function Jokes({data}) {
  return (
        <p>{data}</p>
  )
}

export default Jokes